import React, { Component } from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import ImmutablePropTypes from "react-immutable-proptypes";

import arrow from "../../../images/arrow.svg";
import back from "../../../images/nd-back.svg";

import { isBotxoDomain } from "../../../utils/rebranding";

import DropdownMenuItem from "./DropdownMenuItem";

import styles from "./style.cssmodule.scss";

const isPrevDomain = isBotxoDomain();

class DropdownMenu extends Component {
  static propTypes = {
    menu: ImmutablePropTypes.list, // eslint-disable-line
    itemClick: PropTypes.func, // eslint-disable-line
  };

  static defaultProps = {};

  state = {
    history: [],
  };

  onClick = (data, index) => {
    const label = data.get("label");
    const type = data.get("type");

    if (type === 2) {
      this.setState(prevState => ({
        history: [
          ...prevState.history,
          {
            index,
            label,
          },
        ],
      }));
    } else {
      const { itemClick } = this.props;
      itemClick(data);
    }
  };

  onClickBack = () => {
    const { history } = this.state;
    const newHistory = [...history];
    newHistory.splice(-1, 1);

    this.setState({
      history: newHistory,
    });
  };

  renderItem = (item, index) => (
    <DropdownMenuItem
      key={index}
      data={item}
      itemClick={this.onClick}
      index={index}
    />
  );

  renderMenu = () => {
    const { history } = this.state;
    const { menu } = this.props;
    const newMenu = history.reduce((acc, item) => {
      const subMenu = acc.getIn([item.index, "subMenu"]);
      const type = acc.getIn([item.index, "type"]);

      if (type === 2) {
        return subMenu;
      }

      return acc;
    }, menu);

    return newMenu.map(this.renderItem);
  };

  renderBreadCrumb = () => {
    const { history } = this.state;
    const lastHistoryItem = history[history.length - 1];

    if (!lastHistoryItem) {
      return null;
    }

    const breadcumbContainer = isPrevDomain
      ? styles.titleContainer
      : styles.ndBreadcumbContainer;
    const breadcumbArrow = isPrevDomain ? styles.arrow : styles.ndArrow;
    const breadcumbTitle = isPrevDomain
      ? styles.title
      : styles.ndBreadcumbTitle;

    return (
      <div className={breadcumbContainer} onClick={this.onClickBack}>
        <span className={breadcumbArrow}>
          <img
            src={isPrevDomain ? arrow : back}
            alt="arrow"
            className={styles.img}
          />
        </span>
        <p className={breadcumbTitle}>{lastHistoryItem.label}</p>
      </div>
    );
  };

  render() {
    return (
      <div className={styles["dropdown-menu-component"]}>
        {this.renderBreadCrumb()}
        {this.renderMenu()}
      </div>
    );
  }
}

export default CSSModules(DropdownMenu, styles);
